import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
    selector: 'pxw-promotion-conditions-changed-dialog',
    templateUrl: './promotion-conditions-changed-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class PromotionConditionsChangedDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  open() {
    return this.modalDialog.open().catch(() => {});
  }
}
